import {signal} from "@preact/signals-react";


export const activeTab = signal<number>(0);